import React from 'react';
import { FadeIn } from './FadeIn';
interface HeadlineShowcaseProps {
  lang?: 'en' | 'es';
}
const headlines = {
  en: ["Walk In Tired. Walk Out Transformed. That's the ISASHY Promise.", 'Why Are Women Driving from All Over Connecticut to Visit ISASHY Beauty Center?', 'Finally, a Beauty Center in Waterbury That Treats You Like the Queen You Are'],
  es: ['Entra Cansada. Sal Transformada. Esa es la Promesa ISASHY.', '¿Por Qué las Mujeres Vienen de Todo Connecticut a Visitar ISASHY Beauty Center?', 'Por Fin, un Centro de Belleza en Waterbury Que Te Trata Como la Reina Que Eres']
};
export function HeadlineShowcase({
  lang = 'en'
}: HeadlineShowcaseProps) {
  const h = headlines[lang];
  return <section className="py-24 md:py-32 bg-brand-dark text-brand-cream relative overflow-hidden" data-id="element-101">
      <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none" data-id="element-102">
        <div className="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] rounded-full bg-brand-gold blur-[120px]" data-id="element-103"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] rounded-full bg-brand-gold blur-[120px]" data-id="element-104"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-105">
        <div className="space-y-24" data-id="element-106">
          <FadeIn data-id="element-107">
            <div className="relative text-center" data-id="element-108">
              <span className="absolute -top-12 left-1/2 -translate-x-1/2 text-8xl font-serif text-brand-gold/20 leading-none" data-id="element-109">
                "
              </span>
              <h3 className="font-serif text-3xl md:text-5xl leading-tight" data-id="element-110">
                {h[0]}
              </h3>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-111">
            <div className="relative text-center" data-id="element-112">
              <div className="w-12 h-[1px] bg-brand-gold/30 mx-auto mb-24" data-id="element-113"></div>
              <span className="absolute -top-12 left-1/2 -translate-x-1/2 text-8xl font-serif text-brand-gold/20 leading-none" data-id="element-114">
                "
              </span>
              <h3 className="font-serif text-3xl md:text-5xl leading-tight" data-id="element-115">
                {h[1]}
              </h3>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-116">
            <div className="relative text-center" data-id="element-117">
              <div className="w-12 h-[1px] bg-brand-gold/30 mx-auto mb-24" data-id="element-118"></div>
              <span className="absolute -top-12 left-1/2 -translate-x-1/2 text-8xl font-serif text-brand-gold/20 leading-none" data-id="element-119">
                "
              </span>
              <h3 className="font-serif text-3xl md:text-5xl leading-tight text-brand-gold" data-id="element-120">
                {h[2]}
              </h3>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}